import { render, staticRenderFns } from "./PhotoPageSelector.vue?vue&type=template&id=f7060532&scoped=true&"
import script from "./PhotoPageSelector.vue?vue&type=script&lang=js&"
export * from "./PhotoPageSelector.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPageSelector.vue?vue&type=style&index=0&id=f7060532&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7060532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7060532')) {
      api.createRecord('f7060532', component.options)
    } else {
      api.reload('f7060532', component.options)
    }
    module.hot.accept("./PhotoPageSelector.vue?vue&type=template&id=f7060532&scoped=true&", function () {
      api.rerender('f7060532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StationEvent/PhotoPageSelector.vue"
export default component.exports